import React, { useContext, useState } from 'react'
import styles from './index.module.less'
import classnames from 'classnames'

import { DynamicColumns, SingleLine } from '../common/coupon/index'
import SplitLine from '../common/split-line'
import Narrate from './narrate'
import Gain from './gain'
import { IMachineConfig, IWorth, IState } from '@/components/poizon-fission/types'
import context from '../../context'

interface IProps extends IState {
  lang: string
  fold: boolean
  handle: () => void
}

const CommonCoupon = (props: { your: IWorth; friend: IWorth } & IState) => {
  const { your, friend, flow } = props
  return (
    <div className={classnames(styles.benefits, styles[flow])}>
      <Narrate steps="three" flow={flow} />
      <div className={styles.group}>
        <div>
          <Gain who="your" flow={flow} />
          <DynamicColumns type="aHalf" columns={[your]} flow={flow} />
        </div>
        <SplitLine width={3} />
        <div>
          <Gain who="friend" flow={flow} />
          <DynamicColumns type="aHalf" columns={[friend]} flow={flow} />
        </div>
      </div>
    </div>
  )
}

const CommonCouponPurchase = (props: { your: IWorth; friend: IWorth } & IState) => {
  const { your, friend, flow } = props
  return (
    <div className={classnames(styles.benefits, styles[flow])}>
      <Narrate steps="two" flow={flow} />
      <div className={styles.group}>
        <div>
          <Gain who="your" flow={flow} />
          <DynamicColumns type="aHalf" columns={[your]} flow={flow} />
        </div>
        <SplitLine width={3} />
        <div>
          <Gain who="friend" flow={flow} />
          <DynamicColumns type="aHalf" columns={[friend]} flow={flow} />
        </div>
      </div>
    </div>
  )
}

const CommonHeader = (props: Partial<IProps>) => {
  const { lang, flow } = props
  return (
    <div className={styles.headline}>
      <div className={classnames(styles.start, styles[lang])} />
      <div className={classnames(styles.tips, styles[lang])} />
      {/* <div className={classnames(styles.mask, styles[flow])} /> */}
    </div>
  )
}

/*
  折叠功能
 */
const Spread = (props: { handle: () => void }) => {
  const {
    advantage: { spreadOperation },
  } = useContext(context)
  return (
    <div className={styles.more} onClick={props.handle}>
      <span>{spreadOperation}</span>
      <em></em>
    </div>
  )
}

// 卖家权益
const Seller = (props: IMachineConfig & IProps) => {
  const {
    /* 注册 */
    currencySign,
    registryCouponNameYour1,
    registryCouponValYour1,
    /* 售卖 */
    sellCouponNameYour,
    sellCouponValYour,
    /* 出价 */
    bidCouponNameFriend,
    bidCouponValFriend,
    lang,
    flow,
    fold,
    handle,
  } = props

  const FirstLine = () => (
    <>
      <Narrate steps="one" flow={flow} />
      <Gain who="your" flow={flow} />
      <SingleLine
        flow={flow}
        columns={[
          {
            isDiscount: false,
            currencySign,
            sum: registryCouponValYour1,
            explain: registryCouponNameYour1,
          },
        ]}
      />
    </>
  )
  if (fold) {
    return (
      <>
        <CommonHeader lang={lang} flow={flow} fold={fold} />
        <section className={styles.sharingFold}>
          {/* 一行 */}
          <div className={classnames(styles.benefits, styles[flow])}>
            <FirstLine />
          </div>
          <Spread handle={handle} />
        </section>
      </>
    )
  }
  return (
    <>
      <CommonHeader lang={lang} flow={flow} fold={fold} />
      <section className={classnames(styles.sharing, styles[flow], styles.seller)}>
        {/* 一行 */}
        <div className={classnames(styles.benefits, styles[flow])}>
          <FirstLine />
        </div>
        {/* 三行 */}
        <CommonCoupon
          flow={flow}
          your={{
            type: 'percent',
            currencySign,
            sum: sellCouponValYour,
            explain: sellCouponNameYour,
          }}
          friend={{
            isDiscount: false,
            currencySign,
            sum: bidCouponValFriend,
            explain: bidCouponNameFriend,
          }}
        />
      </section>
    </>
  )
}

// 买卖家权益
const Transaction = (props: IMachineConfig & Partial<IProps>) => {
  const {
    currencySign,
    /* 注册 */
    registryCouponNameYour1,
    registryCouponValYour1,
    registryCouponNameYour2,
    registryCouponValYour2,
    registryCouponNameFriend,
    registryCouponValFriend,
    /* 支付 */
    payCouponNameFriend,
    payCouponValFriend,
    payCouponNameYour,
    payCouponValYour,
    /* 售卖 */
    sellCouponNameYour,
    sellCouponValYour,
    /* 出价 */
    bidCouponNameFriend,
    bidCouponValFriend,
    lang,
    flow,
    fold,
    handle,
  } = props

  const FirstLine = () => (
    <>
      <Narrate steps="one" flow={flow} />
      <div className={styles.group}>
        <div style={{ flex: 2, width: '60%' }}>
          <Gain who="your" flow={flow} />
          <DynamicColumns
            type="twoThirds"
            flow={flow}
            columns={[
              {
                isDiscount: false,
                currencySign,
                sum: registryCouponValYour1,
                explain: registryCouponNameYour1,
              },
              { currencySign, sum: registryCouponValYour2, explain: registryCouponNameYour2 },
            ]}
          />
        </div>
        <SplitLine width={3} />
        <div>
          <Gain who="friend" flow={flow} />
          <DynamicColumns
            type="oneThird"
            flow={flow}
            columns={[
              { currencySign, sum: registryCouponValFriend, explain: registryCouponNameFriend },
            ]}
          />
        </div>
      </div>
    </>
  )

  if (fold) {
    return (
      <>
        <CommonHeader lang={lang} flow={flow} fold={fold} />
        <section className={styles.sharingFold}>
          {/* 一行 */}
          <div className={classnames(styles.benefits, styles[flow])}>
            <FirstLine />
          </div>
          <Spread handle={handle} />
        </section>
      </>
    )
  }
  return (
    <>
      <CommonHeader lang={lang} flow={flow} fold={fold} />
      <section className={classnames(styles.sharing, styles[flow])}>
        {/* 一行 */}
        <div className={classnames(styles.benefits, styles[flow])}>
          <FirstLine />
        </div>
        {/* 二行 */}
        <CommonCouponPurchase
          flow={flow}
          your={{ currencySign, sum: payCouponValYour, explain: payCouponNameYour }}
          friend={{ currencySign, sum: payCouponValFriend, explain: payCouponNameFriend }}
        />
        {/* 三行 */}
        <CommonCoupon
          flow={flow}
          your={{
            type: 'percent',
            currencySign,
            sum: sellCouponValYour,
            explain: sellCouponNameYour,
          }}
          friend={{
            isDiscount: false,
            currencySign,
            sum: bidCouponValFriend,
            explain: bidCouponNameFriend,
          }}
        />
      </section>
    </>
  )
}

// 无大礼包
const Special = (props: IMachineConfig & IProps) => {
  const {
    currencySign,
    /* 注册 */
    registryCouponNameYour1,
    registryCouponValYour1,
    registryCouponNameYour2,
    registryCouponValYour2,
    /* 支付 */
    payCouponNameFriend,
    payCouponValFriend,
    payCouponNameYour,
    payCouponValYour,
    /* 售卖 */
    sellCouponNameYour,
    sellCouponValYour,
    /* 出价 */
    bidCouponNameFriend,
    bidCouponValFriend,
    lang,
    flow,
    fold,
    handle,
  } = props

  const FirstLine = () => (
    <>
      <Narrate steps="one" flow={flow} />
      <Gain who="your" flow={flow} />
      <SingleLine
        flow={flow}
        columns={[
          {
            isDiscount: false,
            currencySign,
            sum: registryCouponValYour1,
            explain: registryCouponNameYour1,
          },
          { currencySign, sum: registryCouponValYour2, explain: registryCouponNameYour2 },
        ]}
      />
    </>
  )

  if (fold) {
    return (
      <>
        <CommonHeader lang={lang} flow={flow} fold={fold} />
        <section className={styles.sharingFold}>
          {/* 一行 */}
          <div className={classnames(styles.benefits, styles[flow])}>
            <FirstLine />
          </div>
          <Spread handle={handle} />
        </section>
      </>
    )
  }
  return (
    <>
      <CommonHeader lang={lang} flow={flow} fold={fold} />
      <section className={classnames(styles.sharing, styles[flow])}>
        {/* 一行 */}
        <div className={classnames(styles.benefits, styles[flow])}>
          <FirstLine />
        </div>
        {/* 二行 */}
        <CommonCouponPurchase
          flow={flow}
          your={{ currencySign, sum: payCouponValYour, explain: payCouponNameYour }}
          friend={{ currencySign, sum: payCouponValFriend, explain: payCouponNameFriend }}
        />
        {/* 三行 */}
        <CommonCoupon
          flow={flow}
          your={{
            type: 'percent',
            currencySign,
            sum: sellCouponValYour,
            explain: sellCouponNameYour,
          }}
          friend={{
            isDiscount: false,
            currencySign,
            sum: bidCouponValFriend,
            explain: bidCouponNameFriend,
          }}
        />
      </section>
    </>
  )
}

function Advantage(props: IMachineConfig & IState) {
  const { flow } = props
  const [fold, setFold] = useState(flow === 'after' ? true : false)
  const { equity, lang } = useContext(context)
  const handle = () => {
    setFold(false)
  }

  // 买卖家权益
  if (equity === 'both') {
    return <Transaction {...props} lang={lang} fold={fold} handle={handle} />
  }
  // 卖家权益
  if (equity === 'seller') {
    return <Seller {...props} lang={lang} fold={fold} handle={handle} />
  }

  // 无大礼包
  return <Special {...props} lang={lang} fold={fold} handle={handle} />
}

export default Advantage

export { default as AdvantageOutside } from './outside'
